import axios, { AxiosResponse } from 'axios';

export interface BaseSectionProps {
  accountOrig: AccountData;
}
export interface BasicSectionProps extends BaseSectionProps {
  saveAccountInfo: (accountInfo: AccountData) => Promise<AxiosResponse<AccountInfoHTTPResponse>>
}
export interface SectionProps extends BasicSectionProps {
  showEditIcon: boolean;
  setEditing: (flag: boolean) => void;
}

export interface PhoneSectionProps extends BasicSectionProps {
  doCancel: () => void;
  changeMode: (mode: PhoneMode) => void;
}

export interface EmailSectionProps extends BasicSectionProps {
  doCancel: () => void;
  changeMode: (mode: EmailMode, accountResponse?: AccountData | undefined, verifySuccess?: boolean) => void;
}

export interface SignInPayload {
  username: string;
  password: string;
  g_recaptcha_response?: string;
  client_id: string;
}

export interface SignInResponse {
  data: {
    authToken: string;
    socialUser: boolean;
    auoUser: boolean;
    minor: boolean;
  };
}

const {
  additionalHeaders,
  accountRootUrl: accountRootURL,
  CLIENT_ID: clientId,
} = window.appAirDrop.config;
const infoUrl = `${accountRootURL}/account/info?client_id=${clientId}`;
const dataPrivacyTokenUrl = `${accountRootURL}/account/dataprivacytoken`;

export function signin(payload: SignInPayload): Promise<AxiosResponse<SignInResponse>> {
  return axios.post<SignInResponse>(
    `${accountRootURL}/account/signin`,
    payload,
    {
      headers: {
        ...(additionalHeaders ?? {}),
        'Content-Type': 'application/json',
      },
    },
  );
}

export function getAccountInfoSvc(authToken: string): Promise<AxiosResponse<AccountInfoHTTPResponse>> {
  return axios.get(infoUrl, {
    headers: {
      ...(additionalHeaders ?? {}),
      'Content-Type': 'application/json',
      'X-Authorization': authToken,
    },
  });
}

export function saveAccountInfoSvc(
  authToken: string,
  payload: AccountData,
): Promise<AxiosResponse<AccountInfoHTTPResponse>> {
  return axios.post(infoUrl, payload, {
    headers: {
      ...(additionalHeaders ?? {}),
      'Content-Type': 'application/json',
      'X-Authorization': authToken,
    },
  });
}

export function getRightToInfoFileSvc(authToken: string) : Promise<AxiosResponse<DataPrivacyResponse>> {
  // Post with no payload in PIUI
  const payload = undefined;
  return axios.post(dataPrivacyTokenUrl, payload, {
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': authToken,
    },
  });
}
